import * as GLOBAL_LABELS from "../labels/global";

export const LABELS = {
    [GLOBAL_LABELS.GLOBAL_DELETE]: "Delete",
    [GLOBAL_LABELS.GLOBAL_CANCEL]: "Cancel",
    [GLOBAL_LABELS.GLOBAL_UNKNOWN]: "Unknown",
};

export default LABELS;
